var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-wrap",
      on: {
        click: function ($event) {
          return _vm.loginWithDiscord()
        },
      },
    },
    [_c("div", { staticClass: "login" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }